import React from 'react'
import { cn } from '@amusnet/react-ui'
import startButtonSvg from '@assets/ultra-play/ultra-play-start-button.svg'
import pauseButtonSvg from '@assets/ultra-play/ultra-play-pause-button.svg'

// Shared start/pause artwork button. `size` is the square px size of the icon.
const UltraPlayPlayPauseButton: React.FC<{
    isPlaying: boolean
    onClick: () => void
    size: number
    disabled?: boolean
    className?: string
}> = ({ isPlaying, onClick, size, disabled, className }) => (
    <button onClick={onClick} disabled={disabled} className={cn('flex items-center justify-center', className)}>
        <img
            src={isPlaying ? pauseButtonSvg : startButtonSvg}
            width={size}
            height={size}
            alt={isPlaying ? 'Pause' : 'Play'}
        />
    </button>
)

export default UltraPlayPlayPauseButton
